import { render, staticRenderFns } from "./KnFooter.vue?vue&type=template&id=ef9c7aa6&"
import script from "./KnFooter.vue?vue&type=script&lang=js&"
export * from "./KnFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports